<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Create Schedulers</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericNew v-if="generic" ref="loadGeneric" :urls="urls"></GenericNew>
        <CustomNew v-else></CustomNew>   

    </main> 
</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/Schedulers/MenuList.vue";
import lang from "@/views/modules/Schedulers/language/en";
import GenericNew from "@/components/layout/shared/generic/NewView.vue";
import CustomNew from "@/views/modules/Schedulers/NewView.vue";

export default {
name: "add-schedulers",
components: {
        breadcrumbs, 
        GenericNew,
        CustomNew,
    },
    data(){
        return {
            generic: false,
            metaList:[
                
                {
                    type:'text',
                    name:'name',
                    label:'Category Name',
                    required: false
                },
                {
                    type:'uploadfile',
                    name:'category_image',
                    label:'Category Image',
                    required: false
                },
                {
                    type:'selectbox',
                    name:'status',
                    label: 'Status',
                    dom_access:true,
                    dom_key:'status_dom',
                    required: true
                }
                
               
            ],
            urls:'api/modules/categorys',
            
            routePath:{
                path:'categorys',
                detail:false
            }
            
        }
    },
    mounted() {
        this.childMethod()
    },
    methods:{
        childMethod(){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.routePath);
            }
        }
    },
}
</script>